import comp from "./SelectKCModal";
export default comp;
